import { reactive } from "vue";
import i18n from "../../../../../i18n";
import { createLoading } from "../../../../../utils/loading";
import {
    createPage,
    createRowActionView,
    createAppPageHeaderTop,
    createManageSelect,
    createManageExtraCreate, createRowActionEdit, createManageActive, createManageArchive
} from "../../../../../utils/page";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { setAppPageHeader } from "../../../../../components/layout/app-layout/app-layout.logic";

import {
    checkAttribute,
    initUseForm, onClickActive, onClickActiveAll, onClickArchive, onClickArchiveAll,
    onClickCreate,
    onClickEdit,
    onClickView
} from "../../../../../utils/form";
import {
    createColumns,
    createField
} from "./user-company-manage.section";
import store from "../../../../../store";
import { has } from "../../../../../utils/menu-context";
import {
    createButtonActive, createButtonArchive,
    createButtonCreate,
    createButtonEdit,
    createButtonSave,
    createButtonView
} from "../../../../../utils/button";
import { setIsLoading as setIsLoadingApp } from "../../../../../app.logic";
import { Button, Col, Row } from "ant-design-vue";

import {
    createForm as createFormUser,
    openModalChangePasswordForCompany
} from "../user/user.logic";
import {
    addRules,
    email,
    equalsLength,
    required, requiredWhen,
    same,
    validateError
} from "../../../../../utils/validate";
import { createConditionForm, createConditionAction } from "./user-company-manage.condition";
import { flatWhereGroup } from "../../../../../utils/search";
import lodash from "lodash";
import {
    emailRequired,
    idCardRequired,
    usernameRequired
} from "../../../../account/login/register.logic";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/security/user";
export const routerPrefix = "user-company-manages";

export const callSave = ({ form }) => store.dispatch(`${actionPrefix}/saveChildrenCompany`, { data: form });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/activeChildrenCompany`, { id })
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/deleteChildrenCompany`, { id })
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAllChildrenCompany`, { ids })
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAllChildrenCompany`, { ids })
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });
export const callConfirmStatusByKey = ({ key }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'CONFIRM_STATUS', key })

export const onSearch = ({ page, props }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({
        criteria: {
            ...page,
            data: [],
            where: [...where, ...createWhereRole({ props })],
            sort: [...sort, { name: "updateDate", type: "DESC" }]
        }
    })
        .then(page => state.page = { ...page, where, sort })
        .finally(() => setIsLoading(false));
};

export const onClickSave = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => {
            setIsLoadingApp(true);
            return callSave({ form: data.useForm.modelRef })
                .finally(() => setIsLoadingApp(false))
                .then((record) => onClickView({ record, routerPrefix })
                );
        })
        .catch((error) => {
            validateError({ error });
            throw error;
        });
};

export const createSearchOneCriteria = ({ id, forLog }) => {
    if (!forLog) {
        return {
            select: ["**"],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }],
            children: [
                { name: "userRoles", select: ["*", "refRole.*"], page: 0, size: 1000000 },
                { name: "userCompanies", select: ["*", "refCompany.*"], page: 0, size: 1000000 }
            ]
        };
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }],
            children: [
                { name: "userRoles", select: ["refRole.name"], page: 0, size: 1000000 },
                { name: "userCompanies", select: ["refCompany.nameTh"], page: 0, size: 1000000 }
            ]
        };
    }

};

export const createFormTitle = ({ data }) => {
    return data.useForm.modelRef.id ? data.useForm.modelRef.fullName : i18n.global.t("button.create");
};

export const createWhereRole = () => {
    const whereGroup = [];
    const userInfo = store.state.resource.auth.info?.user;
    whereGroup.push([
        { name: "refParent.id", type: "UUID", operator: "=", value: userInfo.id }
    ]);
    return flatWhereGroup({ where: whereGroup, logic: "OR" });
};

export const createForm = () => {
    const userInfo = store.state.resource.auth.info?.user;
    return {
        ...createFormUser(),
        refApproveStatus: null,
        userCompanies: [],
        refParent: userInfo
    };
};

export const onSetConfirmStatus = ({ data }) => {
    return callConfirmStatusByKey({ key: 'Approve' }).then(items => {
        const modelRef = data.useForm.modelRef;
        modelRef.refApproveStatus = items[0];
    });
};

export const createRules = ({ data, key }) => {
    const { form } = data;
    const prefix = key ? `${key}.` : "";
    return {
        [`${prefix}refTitle`]: [required],
        [`${prefix}firstNameTh`]: [required],
        [`${prefix}lastNameTh`]: [required],
        [`${prefix}phone`]: [required],
        [`${prefix}email`]: [required, email],
        [`${prefix}userRoles`]: [requiredWhen({ when: () => form.userCompanies.filter(items => items.isDelete != true).length > 0 })]
    };
};

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { form } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ id }) });
    } else {
        promise = Promise.resolve({ data: [useForm.modelRef] });
    }
    return promise
        .then(page => initUseForm({ data, page, routerPrefix }))
        .then(() => {
            initByRole({ props, data, refs })
            onSetConfirmStatus({ data })
        })
        .then(() => initUseForm({ props, data, refs, page: { data: [modelRef] }, routerPrefix }))
        .finally(() => setIsLoading(false));
};

export const initState = ({ props }) => {
    const menuContext = props.menuContext;
    state.manages = [
        createManageSelect({ menuContext }),
        createManageActive({
            menuContext,
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map(d => d.username).join(', ') }),
            onClick: ({ rowSelection }) => onClickActiveAll({ rowSelection, callActiveAll, state, onSearch, setIsLoading }),
        }),
        createManageArchive({
            menuContext,
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map(d => d.username).join(', '), okType: 'danger' }),
            onClick: ({ rowSelection }) => onClickArchiveAll({ rowSelection, callArchiveAll, state, onSearch, setIsLoading }),
        }),
    ];
    state.manageExtras = [createManageExtraCreate({ menuContext, onClick: () => onClickCreate({ routerPrefix }) })];
    state.rowActions = [
        createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) }),
        createRowActionEdit({ menuContext, onClick: ({ record }) => onClickEdit({ record, routerPrefix }) })
    ];
};

export const initForm = ({ props, data, refs }) => {
    checkAttribute({ props, data, refs });
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs, isLoading });
    data.conditionForms = createConditionForm({ props, data, refs, isLoading });
    loadForm({ props, data, refs })
        .then(() => {
            if (props.setAppPageHeader) {
                setAppPageHeader({
                    slots: {
                        top: () => createAppPageHeaderTop({ props, data, refs, state, routerPrefix, onClickView }),
                        default: () => createAppPageHeaderDefault({ props, data, refs })
                    }
                });
            }
        })
};

export const initByRole = ({ props, data, key }) => {
    const { menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    if (has({ menuContext, key: "forCompany" })) {
        if (!model.id) {
            addRules({
                useForm,
                modelRef,
                key: `${prefix}idCard`,
                rules: [required, equalsLength(13), idCardRequired()]
            });
            addRules({ useForm, modelRef, key: `${prefix}email`, rules: [required, email, emailRequired()] });
            addRules({ useForm, modelRef, key: `${prefix}username`, rules: [required, usernameRequired()] });
            addRules({ useForm, modelRef, key: `${prefix}password`, rules: [required] });
            addRules({
                useForm,
                modelRef,
                key: `${prefix}confirmPassword`,
                rules: [required, same(model, "password", i18n.global.t("model.user.password"), i18n.global.t("views.changePassword.confirmPassword"))]
            });
        }
    }
};

export const createAppPageHeaderDefault = ({ props, data, refs }) => {
    const col1 = [];
    const col2 = [];
    const { menuContext, viewOnly } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    const { id, isActive } = modelRef;
    const userInfo = store.state.resource.auth.info?.user;
    const canEdit = state.conditionAction.canEdit({ props, record: initialModel });
    if (id && has({ menuContext, key: "canCreate" })) {
        col1.push(createButtonCreate({ onClick: () => onClickCreate({ routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && id && has({ menuContext, key: "canView" })) {
        col1.push(createButtonView({ onClick: () => onClickView({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (viewOnly && id && isActive && has({ menuContext, key: "canEdit" }) && canEdit) {
        col1.push(createButtonEdit({ onClick: () => onClickEdit({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && (!id || (id && isActive))) {
        col1.push(createButtonSave({
            onClick: () => {
                Promise.resolve().then(() =>{
                       modelRef.userInfo = userInfo
                })
                    .then(() => {
                    onClickSave({ data });
                });
            }
        }));
    }
    if (viewOnly && id && !isActive && has({ menuContext, key: 'canActive' })) {
        col2.push(createButtonActive({ onClick: () => onClickActive({ record: { id }, callActive, setIsLoading: setIsLoadingApp, onClickEdit: () => onClickEdit({ record: { id }, routerPrefix }) }), classStyle: 'm-1' }))
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: 'canArchive' })) {
        col2.push(createButtonArchive({ onClick: () => onClickArchive({ record: { id }, callArchive, setIsLoading: setIsLoadingApp, onClickView: () => onClickView({ record: { id }, routerPrefix }) }), classStyle: 'm-1' }))
    }
    if (id && isActive && has({ menuContext, key: 'canChangePassword' })) {
        col2.push(<Button
            class="btn-warning m-1"
            size="small"
            onClick={() => openModalChangePasswordForCompany({ props, data, refs })}
        >
            <span>{i18n.global.t("button.changePassword")}</span>
        </Button>)
    }
    return <Row type="flex">
        <Col>{col1}</Col>
        <Col class="ml-auto">{col2}</Col>
    </Row>;
};

export const state = reactive({
    columns: createColumns(),
    page: createPage({ options: { select: ["**"] } }),
    tableOptions: { search: { activeKey: "Search" } },
    conditionAction: createConditionAction()
});
